// ======================================================================
// 📁 File: src/modules/ppe/components/engineering/skill/SkillKpiBar.jsx
// 📝 Purpose:
//   Skill Master – KPI Bar
//   ✅ SAME DESIGN AS MachineGroupKpiBar
// ======================================================================

import React from "react";

export default function SkillKpiBar({ rows = [] }) {
  const total = rows.length;
  const active = rows.filter((r) => r.is_active).length;
  const inactive = rows.filter((r) => !r.is_active).length;
  const levelRequired = rows.filter(
    (r) => r.level_required
  ).length;

  return (
    <div
      style={{
        display: "flex",
        gap: 16,
        marginBottom: 20,
        flexWrap: "wrap",
      }}
    >
      {/* Total Skills */}
      <div
        style={{
          flex: 1,
          minWidth: 220,
          background: "#fff",
          borderRadius: 12,
          padding: "16px 20px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          borderLeft: "4px solid #6366f1",
        }}
      >
        <div style={{ fontSize: 13, color: "#6b7280" }}>
          Total Skills
        </div>
        <div style={{ fontSize: 28, fontWeight: 700 }}>
          {total}
        </div>
      </div>

      {/* Active Skills */}
      <div
        style={{
          flex: 1,
          minWidth: 220,
          background: "#fff",
          borderRadius: 12,
          padding: "16px 20px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          borderLeft: "4px solid #22c55e",
        }}
      >
        <div style={{ fontSize: 13, color: "#6b7280" }}>
          Active Skills
        </div>
        <div style={{ fontSize: 28, fontWeight: 700 }}>
          {active}
        </div>
      </div>

      {/* Inactive Skills */}
      <div
        style={{
          flex: 1,
          minWidth: 220,
          background: "#fff",
          borderRadius: 12,
          padding: "16px 20px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          borderLeft: "4px solid #64748b",
        }}
      >
        <div style={{ fontSize: 13, color: "#6b7280" }}>
          Inactive Skills
        </div>
        <div style={{ fontSize: 28, fontWeight: 700 }}>
          {inactive}
        </div>
      </div>

      {/* Level Required */}
      <div
        style={{
          flex: 1,
          minWidth: 220,
          background: "#fff",
          borderRadius: 12,
          padding: "16px 20px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          borderLeft: "4px solid #0ea5e9",
        }}
      >
        <div style={{ fontSize: 13, color: "#6b7280" }}>
          Level Required
        </div>
        <div style={{ fontSize: 28, fontWeight: 700 }}>
          {levelRequired}
        </div>
      </div>
    </div>
  );
}
